import React from "react";
import { cn } from "./cn";

/* Title + supporting line at the top of an auth panel. */
export const AuthHeader = ({ title, subtitle, className = "" }) => (
  <div className={cn("text-center", className)}>
    <h1 className="text-[20.5px] sm:text-[22px] md:text-[26px] leading-[1.15] tracking-[-0.02em] font-bold text-[var(--ink)] font-sans m-0">
      {title}
    </h1>
    {subtitle && (
      <p className="mt-2.5 max-w-[380px] mx-auto text-[12.5px] sm:text-[13px] leading-[1.55] text-[var(--muted)] font-sans">
        {subtitle}
      </p>
    )}
  </div>
);

export default AuthHeader;
